/* icons.js */

import 'vue-material-design-icons/styles.css';

/* used in control panel */
import MapPlus from 'vue-material-design-icons/MapPlus.vue';
import Magnify from 'vue-material-design-icons/Magnify.vue';
import ContentSave from 'vue-material-design-icons/ContentSave.vue';
import TapeMeasure from 'vue-material-design-icons/TapeMeasure.vue';
import Draw from 'vue-material-design-icons/Draw.vue';
import CloseCircle from 'vue-material-design-icons/CloseCircle.vue';
import ShapePolygonPlus from 'vue-material-design-icons/ShapePolygonPlus.vue';
import ShapeRectanglePlus from 'vue-material-design-icons/ShapeRectanglePlus.vue';
import Check from 'vue-material-design-icons/Check.vue';
import Help from 'vue-material-design-icons/Help.vue';
import Ruler from 'vue-material-design-icons/Ruler.vue';

/* used on status panel */
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue';
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue';
import Information from 'vue-material-design-icons/Information.vue';
import Pencil from 'vue-material-design-icons/Pencil.vue'

/* used on control and handle overlays */
import Edit from 'vue-material-design-icons/VectorPolylineEdit.vue'
import Delete from 'vue-material-design-icons/Delete.vue'
import Move from 'vue-material-design-icons/CursorMove.vue'
import Done from 'vue-material-design-icons/Check.vue'

/* used on open/save modal */
import Open from 'vue-material-design-icons/OpenInNew.vue'

/* used on product estimater */
import Seed from 'vue-material-design-icons/Seed.vue'
import Sprout from 'vue-material-design-icons/Sprout.vue'
import Cart from 'vue-material-design-icons/Cart.vue'
import Calculator from 'vue-material-design-icons/Calculator.vue'
import ArrowLeft from 'vue-material-design-icons/ArrowLeftCircleOutline.vue'
import ArrowRight from 'vue-material-design-icons/ArrowRightCircleOutline.vue'

import Account from 'vue-material-design-icons/Account.vue'
import AccountCheck from 'vue-material-design-icons/AccountCheck.vue'
import Menu from 'vue-material-design-icons/Menu.vue'
import Logout from 'vue-material-design-icons/Logout.vue'

import Polygon from 'vue-material-design-icons/VectorPolygon.vue'
import ArrowExpand from 'vue-material-design-icons/ArrowExpand.vue'

/* used on local save dialog */
import Alert from 'vue-material-design-icons/Alert.vue'

/* used on subscribe modal */
import PodiumBronze from 'vue-material-design-icons/PodiumBronze.vue'
import PodiumSilver from 'vue-material-design-icons/PodiumSilver.vue'
import PodiumGold from 'vue-material-design-icons/PodiumGold.vue'

import Cog from 'vue-material-design-icons/Cog.vue'
import Map from 'vue-material-design-icons/Map.vue'
import Cancel from 'vue-material-design-icons/Cancel.vue'

export function registerIcons(app) {
  app.component('map-plus-icon', MapPlus);
  app.component('magnify-icon', Magnify);
  app.component('content-save-icon', ContentSave);
  app.component('draw-icon', Draw);
  app.component('close-circle-icon', CloseCircle);
  app.component('tape-measure-icon', TapeMeasure);
  app.component('shape-polygon-plus-icon', ShapePolygonPlus);
  app.component('shape-rectangle-plus-icon', ShapeRectanglePlus);
  app.component('check-icon', Check);
  app.component('help-icon', Help);
  app.component('chevron-down-icon', ChevronDown);
  app.component('chevron-up-icon', ChevronUp);
  app.component('vector-polyline-edit-icon', Edit);
  app.component('delete-icon', Delete);
  app.component('cursor-move-icon', Move);
  app.component('ruler-icon', Ruler);

  app.component('open-icon', Open);

  app.component('seed-icon', Seed);
  app.component('sprout-icon', Sprout);
  app.component('cart-icon', Cart);
  app.component('calculator-icon', Calculator);
  app.component('arrow-left-icon', ArrowLeft);
  app.component('arrow-right-icon', ArrowRight);
  app.component('information-icon', Information);
  app.component('pencil-icon', Pencil);

  app.component('menu-icon', Menu);
  app.component('account', Account);
  app.component('account-check', AccountCheck);
  app.component('logout-icon', Logout);

  app.component('alert-icon', Alert);

  app.component('podiumbronze-icon', PodiumBronze);
  app.component('podiumsilver-icon', PodiumSilver);
  app.component('podiumgold-icon', PodiumGold);

  app.component('cog-icon', Cog);
  app.component('map-icon', Map);

  app.component('vector-polygon-icon', Polygon);
  app.component('arrow-expand-icon', ArrowExpand);
  app.component('cancel-icon', Cancel);
}

